// https://github.com/oruga-ui/oruga/blob/develop/packages/oruga/src/utils/helpers.js

/**
 * Merge function to replace Object.assign with deep merging possibility
 */
const isObject = (item: any) => typeof item === 'object' && !Array.isArray(item)
const mergeFn = (target: any, source: any, deep = false): any => {
	if (deep || !Object.assign) {
		const isDeep = (prop: any) =>
			isObject(source[prop]) &&
			target !== null &&
			Object.prototype.hasOwnProperty.call(target, prop) &&
			isObject(target[prop])
		let replaced
		if (source === null || typeof source === 'undefined') {
			replaced = {};
		} else {
			replaced = Object.getOwnPropertyNames(source)
				.map((prop) => ({
					[prop]: isDeep(prop)
						? mergeFn(target[prop], source[prop], deep)
						: source[prop]
				}))
				.reduce((a, b) => ({ ...a, ...b }), {})
		}
		return {
			...target,
			...replaced
		}
	} else {
		return Object.assign(target, source)
	}
}
export const merge = mergeFn

export function getUrlParameter(name: string) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	const results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getQueryParam(param: string, url: string) {
	var rx = new RegExp("[?&]" + param + "=([^&]+).*$");
	var returnVal = url.match(rx);
	return returnVal === null ? "" : returnVal[1];
}

export function getScriptParam(param: string) {
	var scripturl = document.currentScript && (document.currentScript as HTMLScriptElement).src
	if (scripturl != null) {
		return getQueryParam(param, scripturl!);
	} else {
		return undefined
	}

}